import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FeatureGuardModule } from '@recruitee/feature-guard';
import {
  BadgeModule,
  DropdownModule,
  FormFieldModule,
  HeadingModule,
  IconButtonComponent,
  IconComponent,
  InputModule,
} from '@recruitee/user-interface';

import { RedactorInsertsDropdownHeaderComponent } from './redactor-inserts-button/redactor-inserts-dropdown-header/redactor-inserts-dropdown-header.component';
import { RedactorInsertsDropdownItemComponent } from './redactor-inserts-button/redactor-inserts-dropdown-item/redactor-inserts-dropdown-item.component';

@NgModule({
  imports: [
    CommonModule,
    FeatureGuardModule,
    DropdownModule,
    IconComponent,
    IconButtonComponent,
    FormFieldModule,
    InputModule,
    HeadingModule,
    BadgeModule,
  ],
  declarations: [RedactorInsertsDropdownItemComponent, RedactorInsertsDropdownHeaderComponent],
  exports: [RedactorInsertsDropdownItemComponent, RedactorInsertsDropdownHeaderComponent],
})
export class RedactorInsertsItemModule {}
